const citations = [
    {
        citation: "Associated Press, 2025: “At least 9 people are dead, including 8 in Kentucky, in latest blast of winter weather”. KKTV.com.",
        url: "https://www.kktv.com/2025/02/16/flooding-us-southeast-leaves-least-4-dead-snow-ice-wind-cause-winter-misery-elsewhere/"
    },
    {
        citation: "Belski, J., 2020: “On this Day: 5 Years Ago, Nearly 200 Semis Stranded after I-65 Hammered with Snow”. WLKY, Louisville, KY.",
        url: "https://www.wlky.com/article/on-this-day-5-years-ago-nearly-200-semis-stranded-after-i-65-hammered-with-snow/31228587"
    },
    {
        citation: "Carpenter, N., Z. Wang, and M. Lynch, 2014: Earthquakes in Kentucky: Hazards, Mitigation, and Emergency Preparedness, Kentucky Geological Survey, University of Kentucky, 16 pg.",
        url: ""
    },
    {
        citation: "Davies, R., 2015: “State of Emergency Declared as Floods in Kentucky Leave 2 Dead and Several Missing”. Floodlist.com.",
        url: "https://floodlist.com/america/usa/kentucky-floods-2-dead-several-missing-july-2015"
    },
    {
        citation: "Hicks, J., 2024: “Helene hammering Kentucky with wind and rain”. Kentucky Public Radio, Louisville Public Media.",
        url: "https://www.lpm.org/news/2024-09-27/helene-hammering-kentucky-with-wind-and-rain"
    },
    {
        citation: "Hill, J., 2005: Kentucky Weather. The University Press of Kentucky, Lexington, Kentucky. 198 pg.",
        url: ""
    },
    {
        citation: "James, M., 2019: “Top Weather Events in Kentucky over the Decade”, WKYT.",
        url: "https://www.wkyt.com/content/news/Top-weather-events-in-Central-Kentucky-over-the-decade-566572991.html"
    },
    {
        citation: "Kentucky.gov, 2021: “Gov. Beshear Requests Major Disaster Declaration from Federal Government”.",
        url: "https://www.kentucky.gov/Pages/Activity-stream.aspx?n=GovernorBeshear&prId=669"
    },
    {
        citation: "LEX18, 2020: “Anniversary of the February 15-16, 2015 Snow”. Lexington, KY.",
        url: "https://www.lex18.com/anniversary-of-february-15-16-2015-snow"
    },
    {
        citation: "Midwest Regional Climate Center, cli-MATE.",
        url: "https://mrcc.purdue.edu/CLIMATE/welcome.jsp"
    },
    {
        citation: "Mudd, A., 2025: Where was the most rainfall recorded in Kentucky? Lexington may break record.” Lexington Herald Leader.",
        url: "https://www.kentucky.com/news/weather-news/article303676851.html"
    },
    {
        citation: "National Center for Environmental Information (NCEI), “Climate at a Glance”.",
        url: "https://www.ncei.noaa.gov/access/monitoring/climate-at-a-glance/"
    },
    {
        citation: "National Weather Service. “Flooding in Kentucky”.",
        url: "https://www.weather.gov/safety/flood-states-ky"
    },
    {
        citation: "National Weather Service, JKL. “The Flash Flood Disaster of July 1939”.",
        url: "https://www.weather.gov/jkl/frozenflood1939"
    },
    {
        citation: "National Weather Service, JKL. “Historic July 26th-July 30th, 2022 Eastern Kentucky Flooding”.",
        url: "https://www.weather.gov/jkl/July2022Flooding"
    },
    {
        citation: "National Weather Service, JKL. “Remembering the Flood of ‘57”.",
        url: "https://www.weather.gov/jkl/1957flood"
    },
    {
        citation: "National Weather Service, JKL. “September 27, 2024: Hurricane Helene’s remnants bring widespread wind damage to eastern Kentucky”.",
        url: "https://www.weather.gov/jkl/2024-09-27-easternkentucky-helene-damaging-winds#:~:text=The%20remnants%20of%20Hurricane%20Helene,fast%2Dmoving%20Category%204%20hurricane"
    },
    {
        citation: "National Weather Service, LMK. “April 2-6, 2025 Severe Weather and Flooding”.",
        url: "https://www.weather.gov/lmk/2025-04-02-Severe_Event"
    },
    {
        citation: "National Weather Service, LMK. “December 10-11, 2021 Tornadoes”.",
        url: "https://www.weather.gov/lmk/December112021Tornadoes"
    },
    {
        citation: "National Weather Service, LMK. “February 2025 Kentucky Flooding Summary”.",
        url: "https://www.weather.gov/lmk/KYFlooding#:~:text=A%20prolonged%20period%20of%20heavy,central%20portions%20of%20the%20state"
    },
    {
        citation: "National Weather Service, LMK. “Flooding May 1-2, 2010: How it Happened”.",
        url: "https://www.weather.gov/lmk/flood_050210_how_it_happened"
    },
    {
        citation: "National Weather Service, LMK. “Ice and Snow Storm of January 26-28, 2009”.",
        url: "https://www.weather.gov/lmk/jan_2009_ice_and_snow"
    },
    {
        citation: "National Weather Service, LMK. “Remnants of Hurricane Ike September 14, 2008”.",
        url: "https://www.weather.gov/lmk/sep_14_08"
    },
    {
        citation: "National Weather Service, LMK. “Top Ten Heat Events”.",
        url: "https://www.weather.gov/lmk/top10heat#:~:text=The%20drought%20in%201954%20was,or%20extreme%20drought%20through%20November"
    },
    {
        citation: "National Weather Service, LMK. “Top Ten Winter Weather Events”.",
        url: "https://www.weather.gov/lmk/top10winter"
    },
    {
        citation: "National Weather Service, LMK. “Tornadoes of April 3, 1974”.",
        url: "https://www.weather.gov/lmk/tornado_climatology_april31974"
    },
    {
        citation: "National Weather Service, LMK. “Tornadoes of March 27, 1890”.",
        url: "https://www.weather.gov/lmk/tornado_climatology_march271890"
    },
    {
        citation: "National Weather Service, LMK. “Violent Tornadoes in Kentucky”.",
        url: "https://www.weather.gov/lmk/violent_tornadoes_kentucky"
    },
    {
        citation: "National Weather Service, PAH. “Summary of Historic Flash Flooding on July 19, 2023”.",
        url: "https://www.weather.gov/pah/FloodingJuly19_2023"
    },
    {
        citation: "National Weather Service, PAH. “The Violent Tornado Outbreak of December 10-11, 2021”.",
        url: "https://www.weather.gov/pah/December-10th-11th-2021-Tornado"
    },
    {
        citation: "Operle, D., 2025: “For all but one Kentucky County, 2024 was one of the five hottest years on record”. WKMS, Louisville Public Media.",
        url: "https://www.lpm.org/news/2025-02-17/for-all-but-one-kentucky-county-2024-was-one-of-the-five-hottest-years-on-record"
    },
    {
        citation: "Pilgrim, E., 2024: Former soldier, Meade County community remember devastation of 1974 tornado.” U.S. Army.",
        url: "https://www.army.mil/article/275125/former_soldier_meade_county_community_remember_devastation_of_1974_tornado#:~:text=The%20clouds%20also%20reminded%20many,way%20the%20nation%20tracks%20storms"
    },
    {
        citation: "Rostvedt, J. O., et al., 1968: Summary of Floods in the United States during 1963. Geological Survey Water-supply Paper 1830-B. Washington D.C., 130 pg.",
        url: "https://doi.org/10.3133/wsp1830B"
    },
    {
        citation: "Sergio, A., Sarah Bolgan, Alden German (WHAS), Doug Proffitt, Reed Yadon, Colleen Peterson, Ben Pine, 2024: ”50 years later: Remembering the 1974 super tornado outbreak”. WHAS-11, Louisville, KY.",
        url: "https://www.whas11.com/article/news/local/1974-super-tornado-outbreak-second-largest-us-history-kentucky-indiana-50-years-ago/417-0a265f8b-6a22-4ae3-ad61-f699ef2c3806#:~:text=The%20twisters%20took%20a%20tragic,injuring%20more%20than%20200%20others"
    },
    {
        citation: "WKU News, 2013: “March 2013 one of coldest on record across Kentucky”.",
        url: "https://www.wku.edu/news/articles/index.php?view=article&articleid=2121&return=archive#:~:text=Nearly%203%20feet%20of%20snow,at%2015.8%20degrees%20below%20normal"
    },
    {
        citation: "WKYT News Staff, 2023: “March 3rd Storms Declared Kentucky’s Fourth Billion-Dollar Weather Event”. Lexington, Kentucky.",
        url: "https://www.wkyt.com/2023/05/09/march-3rd-storms-declared-kentuckys-fourth-billion-dollar-weather-event/"
    }
];

export default citations;